var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", { staticClass: "mb-3" }, [
      _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrap-block" },
      _vm._l(_vm.summaryBlocks, function(data, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "summary-block",
            class: data.type,
            style: _vm.styleDivBlock(data)
          },
          [
            _c("div", { staticClass: "item-name" }, [
              _vm._v(_vm._s(data.name))
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._m(0, true)
          ]
        )
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _vm.type === "requestor"
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center mb-2" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn grey btn-import-form m__r--5",
                  attrs: { disabled: "" }
                },
                [
                  _c("i", { staticClass: "fa fa-plus fa-lg" }),
                  _vm._v(" Add\n      ")
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn grey btn-import-form",
                  attrs: { disabled: "" }
                },
                [
                  _c("i", { staticClass: "fa fa-search fa-lg" }),
                  _vm._v(" Search\n      ")
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          _vm._l(_vm.columns, function(column) {
            return _c(
              "div",
              { key: column, staticClass: "column" },
              [
                _c(
                  "div",
                  {
                    staticClass: "header-list",
                    staticStyle: { cursor: "default !important" }
                  },
                  [
                    _c("div", { staticClass: "column-name" }, [
                      _vm._v(_vm._s(column))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(4, function(index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "column-preview",
                      class: { "bg-gray": index === 2 || index === 4 },
                      staticStyle: { cursor: "default !important" }
                    },
                    [_c("div", { staticClass: "content-preview" })]
                  )
                })
              ],
              2
            )
          })
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-count" }, [
      _vm._v("\n        0 "),
      _c("span", [_vm._v("record(s)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b067537c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b067537c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyOvertime.vue
// module id = null
// module chunks = 